
import { Action } from "../actions/changeFlyerDetailsActions";
import { ActionType } from "../actionTypes";

export interface FlyerDetailsState {
  isChangedFlyerData: boolean;
}

export class FlyerDetailsInitialState implements FlyerDetailsState {
  isChangedFlyerData = false;
}


const initialState = new FlyerDetailsInitialState();

const reducer = (state: FlyerDetailsState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.FLYER_DETAILS_ANY_DATA_WAS_CHANGED:
      return { ...state, isChangedFlyerData : action.payload };

    default:
      return state;
  }
};

export default reducer;
